export default "__VITE_ASSET__b022f537__"